import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientDetailsComponent } from './patient-details/patient-details.component';
import { PagesComponent } from '../pages.component';
import { PatientsComponent } from './patients/patients.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AuthGuard } from 'src/guards/auth.guard';
import { SelectFormComponent } from '../select-form/select-form.component';





export const routes: Routes = [
  {
    path: '',
    component: PagesComponent, 
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'patients', pathMatch: 'full' },
      { path: 'patients', component: PatientsComponent },
      { path: 'patient-details/:id', component: PatientDetailsComponent, data: { breadcrumb: 'Patient-Details' } },
      { path: 'select-form', component: SelectFormComponent, data: { breadcrumb: 'Select-Form' } }
      
      

    ]
  },
];

@NgModule({
  declarations: [
    PatientDetailsComponent, 
    PatientsComponent, 
    SelectFormComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class PatientsModule { }
